// extracted by mini-css-extract-plugin
export var avatarContainer = "_3j-1";
export var largeAvatarContainer = "_3j-2";
export var smallAvatarContainer = "_3j-0";